import {
  HostingClientReportType,
  InfrastructureReportType,
  SiteReportType,
  type IHostingClientsReportFilters,
  type IInfrastructureReportFilters,
  type ISiteReportFilters,
} from '@/types/eos/filters'
import { downloadFile } from '@/util'
import { DateTime } from 'luxon'

import axios from 'axios'

export const getSiteReport = async (siteID: string, filters: ISiteReportFilters): Promise<any> => {
  const isXlsx = filters.type === SiteReportType.DOWNTIME
  const res = await axios.get(`${import.meta.env.VITE_APP_SITES_ENDPOINT}/${siteID}/reports`, {
    params: filters,
    responseType: isXlsx ? 'arraybuffer' : undefined,
  })

  const fileExtension = filters.type === SiteReportType.DOWNTIME ? 'xlsx' : 'csv'

  const startDate = DateTime.fromISO(filters.start_datetime).toFormat('yyyy-MM-dd')
  const endDate = DateTime.fromISO(filters.end_datetime).toFormat('yyyy-MM-dd')
  const filename = `${siteID}_${filters.type}-REPORT_${startDate}_to_${endDate}.${fileExtension}`

  const file =
    fileExtension === 'xlsx'
      ? new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      : new Blob([res.data], { type: 'text/csv' })

  downloadFile(file, filename)
}

export const getHostingClientsReport = async (filters: IHostingClientsReportFilters): Promise<any> => {
  const res = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/hosting-clients/reports`, {
    params: filters,
    responseType: 'arraybuffer',
  })

  const monthName = DateTime.fromObject({ month: filters.month }).toFormat('MMMM')

  const fileExtension = 'xlsx' // Default to xlsx
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheetv'
  let filename = ''

  if (filters.type === HostingClientReportType.UPTIME) {
    filename = `HOSTING-CLIENTS_${filters.type}-REPORT_${monthName}${filters.year}.${fileExtension}`
  } else if (filters.type === HostingClientReportType.BILLING) {
    filename = `${filters.hosting_client_name}_${filters.type}-REPORT_${monthName}${filters.year}.${fileExtension}`
  }

  const file = new Blob([res.data], { type: fileType })
  downloadFile(file, filename)
}

export const getInfrastructureReport = async (filters: IInfrastructureReportFilters): Promise<any> => {
  const res = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/infrastructure/reports`, {
    params: filters,
  })

  let fileExtension = 'csv' // Default to csv
  if (filters.type === InfrastructureReportType.UPTIME) {
    fileExtension = 'csv'
  }

  const monthName = DateTime.fromObject({ month: filters.month }).toFormat('MMMM')
  const filename = `${filters.infrastructure_type.toUpperCase()}_${filters.type}-REPORT_${monthName}${filters.year}.${fileExtension}`

  const file = new Blob([res.data], { type: 'text/csv' })
  downloadFile(file, filename)
}
